export function trimStringObject(formData: object) {
  const newObject = Object.keys(formData);
  newObject.forEach(atributeValue => {
    if (typeof formData[atributeValue] === 'string') {
      formData[atributeValue] = formData[atributeValue]?.trim();
    }
  });
  return formData;
}
